/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ESelectiveProcessAdmissionType } from "../types/ESelectiveProcessAdmissionType.ts";

/**
 * @description 1 = Vestibular | 2 = Enem | 3 = SecondGraduation | 4 = VestibularWithSchoolHistory |
 */
export const eSelectiveProcessAdmissionTypeSchema = z
  .union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)])
  .describe(
    "1 = Vestibular | 2 = Enem | 3 = SecondGraduation | 4 = VestibularWithSchoolHistory | ",
  ) as unknown as ToZod<ESelectiveProcessAdmissionType>;
